import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة نقطة الندى - احسب درجة حرارة تشبع الهواء";
const DESCRIPTION =
  "استخدم حاسبة نقطة الندى لحساب درجة الحرارة التي يجب أن يبرد إليها الهواء ليصل إلى حالة التشبع ويبدأ في تكوين الندى. تعتبر هذه الأداة ضرورية لفهم الرطوبة والظروف البيئية. احصل على قيمة دقيقة لنقطة الندى لتحليل الظروف الجوية والمناخية بدقة.";
const KEYWORDS =
  "حاسبة نقطة الندى, حساب نقطة الندى, درجة حرارة الندى, الرطوبة, تحليل الندى, الأدوات البيئية, قياس الرطوبة";
const OG_URL = "https://do-calculate.com/calculator/ar/dew-point-calculator/";
const DewPointCalculator = () => {
  const [airTemperature, setAirTemperature] = useState("");
  const [humidity, setHumidity] = useState("");
  const [dewPoint, setDewPoint] = useState("");
  const [unit, setUnit] = useState("Celsius");
  const [dewPointUnit, setDewPointUnit] = useState("Celsius");
  const [error, setError] = useState("");
  const [results, setResults] = useState(null);
  const calculateSaturationVaporPressure = (temp) => {
    return 610.78 * Math.exp((17.27 * temp) / (temp + 237.3));
  };
  const calculateVaporPressure = (saturationPressure, relativeHumidity) => {
    return (relativeHumidity / 100) * saturationPressure;
  };
  const calculateAbsoluteHumidity = (vaporPressure, temp) => {
    return (2.16679 * vaporPressure) / (temp + 273.15);
  };
  const calculateMoistureVolumeConcentration = (vaporPressure) => {
    const atmosphericPressure = 101325;
    return (vaporPressure / atmosphericPressure) * 1e6;
  };
  const calculateMoistureWeightConcentration = (absoluteHumidity) => {
    const airDensity = 1.225;
    return (absoluteHumidity / airDensity) * 1e6;
  };
  const calculateDewPoint = (airTemp, relativeHumidity) => {
    const temp =
      unit === "Celsius"
        ? airTemp
        : unit === "Fahrenheit"
        ? (airTemp - 32) * (5 / 9)
        : airTemp - 273.15;
    const a = 17.27;
    const b = 237.7;
    const alpha = (a * temp) / (b + temp) + Math.log(relativeHumidity / 100);
    return (b * alpha) / (a - alpha);
  };
  const calculateHumidity = (airTemp, dewPointTemp) => {
    const saturationVaporPressure = calculateSaturationVaporPressure(airTemp);
    const vaporPressure = calculateSaturationVaporPressure(dewPointTemp);
    return (vaporPressure / saturationVaporPressure) * 100;
  };
  const handleCalculate = () => {
    try {
      const airTemp = parseFloat(airTemperature);
      const relativeHumidity = parseFloat(humidity);
      const dewPointTemp = parseFloat(dewPoint);
      if (airTemperature && humidity) {
        const calculatedDewPoint = calculateDewPoint(airTemp, relativeHumidity);
        setDewPoint(calculatedDewPoint.toFixed(2));
      } else if (airTemperature && dewPoint) {
        if (airTemp <= dewPointTemp) {
          throw new Error(
            "درجة حرارة الهواء يجب أن تكون أكبر من درجة حرارة نقطة الندى."
          );
        }
        const calculatedHumidity = calculateHumidity(airTemp, dewPointTemp);
        setHumidity(calculatedHumidity.toFixed(2));
      } else if (humidity && dewPoint) {
        const temp = dewPointTemp;
        setAirTemperature(temp.toFixed(2));
      } else {
        throw new Error("يرجى إدخال قيمتين لحساب الثالثة.");
      }
      setError("");
      const saturationVaporPressure = calculateSaturationVaporPressure(airTemp);
      const vaporPressure = calculateVaporPressure(
        saturationVaporPressure,
        relativeHumidity || calculateHumidity(airTemp, dewPointTemp)
      );
      const absoluteHumidity = calculateAbsoluteHumidity(
        vaporPressure,
        airTemp
      );
      const moistureVolumeConcentration =
        calculateMoistureVolumeConcentration(vaporPressure);
      const moistureWeightConcentration =
        calculateMoistureWeightConcentration(absoluteHumidity);
      setResults({
        saturationVaporPressure,
        vaporPressure,
        absoluteHumidity,
        moistureVolumeConcentration,
        moistureWeightConcentration,
      });
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة نقطة الندى</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تعتبر حاسبة نقطة الندى أداة مفيدة لتحديد العلاقة بين درجة
                  الحرارة، الرطوبة النسبية، ونقطة الندى. هذه الحاسبة الخاصة
                  تميزت بتوفير مرونة أكبر للمستخدم، حيث يمكنه إدخال قيمتين من
                  القيم الثلاث المذكورة (درجة الحرارة، الرطوبة النسبية، ونقطة
                  الندى) وحساب القيمة الثالثة تلقائياً. تتميز هذه الحاسبة
                  بمرونتها وسهولة استخدامها، مما يجعلها أداة قيمة للأشخاص الذين
                  يحتاجون إلى حساب أي من القيم الثلاث بناءً على القيمتين
                  المعروفة لديهم. سواء كنت مهتمًا بالأرصاد الجوية، الزراعة، أو
                  أي مجال آخر يتطلب معرفة بنقطة الندى، فإن هذه الحاسبة ستكون
                  مفيدة لك.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>حاسبة نقطة الندى</h2>
                </div>
                <div className="bg-warning text-black text-center">
                  <p>
                    يرجى إدخال <b>اثنين فقط</b> من المتغيرات الثلاثة التالية
                    لحساب الثالث:
                  </p>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="AirTemp" className="form-label ms-2">
                          درجة حرارة الهواء
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل درجة الحرارة"
                        value={airTemperature}
                        onChange={(e) => setAirTemperature(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <select
                        id="AirTemp"
                        value={unit}
                        onChange={(e) => setUnit(e.target.value)}
                        className="form-control ms-2"
                        style={{ width: "120px" }}
                      >
                        <option value="Celsius">Celsius °C</option>
                        <option value="Fahrenheit">Fahrenheit °F</option>
                        <option value="Kelvin">Kelvin K</option>
                      </select>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          الرطوبة النسبية
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل الرطوبة"
                        value={humidity}
                        onChange={(e) => setHumidity(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <span className="ms-2"> %</span>
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label htmlFor="DewPoint" className="form-label ms-2">
                          درجة حرارة نقطة الندى
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="أدخل نقطة الندى"
                        value={dewPoint}
                        onChange={(e) => setDewPoint(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                      <select
                        id="DewPoint"
                        value={dewPointUnit}
                        onChange={(e) => setDewPointUnit(e.target.value)}
                        className="form-control ms-2"
                        style={{ width: "120px" }}
                      >
                        <option value="Celsius">Celsius °C</option>
                        <option value="Fahrenheit">Fahrenheit °F</option>
                        <option value="Kelvin">Kelvin K</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                    <br />
                    { error && (
                      <p style={{ color: "red" }}>{error}</p>
                    )}
                    <br />
                    { results && (
                      <div className="p-3 mb-2 bg-success text-white">
                        <hr />
                        <p>النتائج:</p>
                        <p>
                          ضغط بخار الماء (Pa):{" "}
                          {results.vaporPressure.toFixed(2)}
                        </p>
                        <p>
                          ضغط بخار الماء المشبع (Pa):{" "}
                          {results.saturationVaporPressure.toFixed(2)}
                        </p>
                        <p>
                          الرطوبة المطلقة (g/m³):{" "}
                          {results.absoluteHumidity.toFixed(2)}
                        </p>
                        <p>
                          تركيز الرطوبة الحجمي (ppm):{" "}
                          {results.moistureVolumeConcentration.toFixed(2)}
                        </p>
                        <p>
                          تركيز الرطوبة الوزني (ppm):{" "}
                          {results.moistureWeightConcentration.toFixed(2)}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-10">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما هي نقطة الندى؟</h3>
              </div>
              <div className="info-section-body">
                <p>
                  نقطة الندى هي درجة الحرارة التي يجب تبريد الهواء إليها حتى
                  يصبح مشبعاً ببخار الماء ويتكثف على شكل ندى. بعبارة أخرى، هي
                  درجة الحرارة التي يبدأ عندها بخار الماء في الهواء بالتكثف إلى
                  قطرات ماء. أهمية نقطة الندى: تحديد الرطوبة: تعتبر نقطة الندى
                  مؤشراً هاماً للرطوبة في الهواء. كلما اقتربت نقطة الندى من درجة
                  حرارة الهواء، زادت الرطوبة النسبية. التنبؤ بالظواهر الجوية:
                  تستخدم نقطة الندى للتنبؤ بتكون الضباب والندى والصقيع. تقييم
                  الراحة الحرارية: تؤثر نقطة الندى على الشعور بالراحة الحرارية
                  للإنسان. الزراعة والصناعة: تستخدم نقطة الندى في العديد من
                  المجالات الصناعية والزراعية، مثل التحكم في الرطوبة في الصناعات
                  الدوائية والغذائية. باختصار، نقطة الندى هي مقياس مهم للرطوبة
                  في الهواء، وهي تستخدم في العديد من التطبيقات العملية.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>كيف يتم حساب نقطة الندى؟</h3>
              </div>
              <div className="info-section-body">
                <p>
                  يتم حساب نقطة الندى باستخدام معادلات رياضية معقدة تربط بين
                  درجة الحرارة والرطوبة النسبية. هذه المعادلات تأخذ في الاعتبار
                  العلاقة بين بخار الماء في الهواء ودرجة حرارته. بشكل عام، يتم
                  اتباع هذه الخطوات: تحويل القيم: يتم تحويل القيم المدخلة (درجة
                  الحرارة والرطوبة النسبية) إلى الوحدات المناسبة (عادةً درجة
                  مئوية ونسبة مئوية). تطبيق المعادلة: يتم تطبيق معادلة رياضية
                  محددة على القيم المحولة لحساب درجة حرارة نقطة الندى. هذه
                  المعادلة تأخذ في الاعتبار العديد من العوامل، بما في ذلك الضغط
                  الجوي. تحويل النتيجة: يتم تحويل نتيجة الحساب إلى الوحدة
                  المطلوبة (عادةً درجة مئوية) وإظهارها للمستخدم. ملاحظة:
                  المعادلات المستخدمة لحساب نقطة الندى قد تختلف قليلاً بين
                  الحاسبات المختلفة، ولكن المبدأ الأساسي هو نفسه.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>ما هي الرطوبة؟</h3>
              </div>
              <div className="info-section-body">
                <p>
                  الرطوبة هي كمية بخار الماء (الطور الغازي للماء) في الهواء. وهي
                  مؤشر لوجود الندى والصقيع والضباب والهطول. يتأثر الحد الأقصى
                  لكمية بخار الماء التي يمكن احتواؤها في الهواء بالدرجة الحرارة؛
                  فكلما ارتفعت درجة الحرارة، زادت كمية بخار الماء التي يمكن أن
                  يحتويها الهواء قبل الوصول إلى التشبع. غالبًا ما يتم مناقشة
                  الرطوبة من حيث الرطوبة المطلقة والرطوبة النسبية، كما هو الحال
                  في هذه الحاسبة. يتم إرجاع قيمة الرطوبة المطلقة كجزء من نتائج
                  الحساب، ولكن الرطوبة النسبية هي الأكثر استخدامًا في الحياة
                  اليومية وتستخدم كجزء من حساب درجة حرارة نقطة الندى. الرطوبة
                  المطلقة هي قياس لمحتوى الماء في الهواء، وعادة ما تكون بوحدات
                  جرام لكل متر مكعب. يتم حسابها بقسمة الكتلة الكلية لبخار الماء
                  على حجم الهواء. مع وجود نفس كمية بخار الماء في الهواء، لا
                  تتغير الرطوبة المطلقة مع درجة الحرارة عند حجم ثابت. إذا لم يكن
                  الحجم ثابتًا، كما هو الحال في الغلاف الجوي، تتغير الرطوبة
                  المطلقة استجابة لتغيرات الحجم الناجمة عن اختلاف درجة الحرارة
                  والضغط. الرطوبة النسبية تقارن النسبة الحالية للرطوبة المطلقة
                  بالرطوبة القصوى لدرجة حرارة معينة وتعبر عن هذه القيمة كنسبة
                  مئوية. كلما ارتفعت النسبة المئوية، ارتفعت الرطوبة. تتأثر كل من
                  درجة الحرارة والضغط. مع وجود نفس كمية بخار الماء، سيكون هناك
                  رطوبة نسبية أعلى في الهواء البارد أكثر من الهواء الدافئ.
                  الرطوبة النسبية هي مقياس شائع الاستخدام في تقارير الطقس
                  والتنبؤات وهي مؤشر جيد للهطول والندى والصقيع والضباب ودرجة
                  الحرارة الظاهرية. درجة الحرارة الظاهرية هي درجة الحرارة التي
                  يدركها الإنسان. في الصيف، كلما ارتفعت الرطوبة النسبية، ارتفعت
                  درجة الحرارة الظاهرية. هذا نتيجة لانخفاض الرطوبة العالية لمعدل
                  تبخر العرق، مما يزيد من درجة الحرارة المدركة. تشير الرطوبة
                  النسبية بنسبة 100٪ إلى أن الهواء مشبع، مما يعني أنه في ظل
                  الظروف الحالية، لا يمكن لبخار الماء في الهواء أن يزيد أكثر في
                  الظروف العادية. الرطوبة النسبية بنسبة 100٪ هي أيضًا النقطة
                  التي يمكن أن يبدأ عندها تشكل الندى.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DewPointCalculator;
